import { Link } from "react-router-dom";

export default function Logo({ className = "", showHub = true, variant = "default", testId = "logo" }) {
  const hubColor = variant === "light" ? "text-white" : "text-[color:var(--ink)]";
  return (
    <Link
      to="/"
      data-testid={testId}
      className={`inline-flex items-center gap-1 ${className}`}
      aria-label="StUpEco Hub home"
    >
      <img
        src="/assets/stupeco-logo.png"
        alt="StUpEco"
        className="h-7 w-auto select-none"
        draggable="false"
      />
      {showHub && (
        <span className={`font-display text-[18px] font-semibold leading-none tracking-tight ${hubColor}`}>
          Hub
        </span>
      )}
    </Link>
  );
}
